import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import AppState from "./interface";

const initialState: AppState = {
  loading: true,
  error: "",
  sidebarShow: false,
  sidebarShowMobile: false,
  hintBackdropShow: false,
  isWidgetsContainerConfigurable: true,
  companyAccountShow: true,
};

export const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setLoading(state, { payload }: PayloadAction<boolean>) {
      state.loading = payload;
    },
    setError(state, { payload }: PayloadAction<string>) {
      state.error = payload;
    },
    setSidebarShow(state, { payload }: PayloadAction<boolean>) {
      state.sidebarShow = payload;
    },
    setSidebarShowMobile(state, { payload }: PayloadAction<boolean>) {
      state.sidebarShowMobile = payload;
    },
    setHintBackdropShow(state, { payload }: PayloadAction<boolean>) {
      state.hintBackdropShow = payload;
    },
    setIsWidgetsContainerConfigurable(state, { payload }: PayloadAction<boolean>) {
      state.isWidgetsContainerConfigurable = payload;
    },
    setCompanyAccountShow(state, { payload }: PayloadAction<boolean>) {
      state.companyAccountShow = payload;
    },
  },
});

export default appSlice.reducer;
